import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import SSITabViewHeader from './SSITabViewHeader';
import { SSITabViewContainerStyled as Container } from '../../../styles/components';
const Tab = (props) => {
    return _jsx(React.Fragment, { children: props.children });
};
const SSITabView = (props) => {
    const { routes = [] } = props;
    const [activeTabIndex, setActiveTabIndex] = React.useState(1);
    const [content, setContent] = React.useState();
    React.useEffect(() => {
        routes.forEach((route, index) => {
            if (index + 1 === activeTabIndex) {
                setContent(route.content);
            }
        });
    }, [routes, activeTabIndex]);
    const onTabChange = async (tabIndex) => {
        setActiveTabIndex(tabIndex);
    };
    return (_jsxs(Container, { children: [_jsx(SSITabViewHeader, { navigationState: {
                    routes: routes,
                    index: activeTabIndex,
                }, onIndexChange: onTabChange }), _jsx(Tab, { children: content })] }));
};
export default SSITabView;
